"use client";

import React, { useState } from "react";
import UniversityTab from "@packages/shared-components/common-utilities/searchBar/search-input-pods/universitytab";
import AdviceTab from "@packages/shared-components/common-utilities/searchBar/search-input-pods/advicetab";
import CourseTab from "@packages/shared-components/common-utilities/searchBar/search-input-pods/coursetab";
import Image from "next/image";
import emitter from "@packages/lib/eventEmitter/eventEmitter";
import UcasComponent from "@packages/shared-components/common-utilities/popups/ucas-calculator/ucascomponent";
import { getCookieValue } from "@packages/lib/utlils/commonFunction";
import { SearchTabIntNames } from "@packages/shared-components/common-utilities/searchBar/search-utils/search.model";
import ClearingSearch from "@packages/shared-components/common-utilities/searchBar/search-input-pods/ClearingSearch";
import { GA4DataLayer, GA4DataLayerFn, getCookie } from "@packages/lib/utlils/helper-function";
import {parseUCASCookie} from "@packages/lib/utlils/getUcasvalue";
import { GAConstants } from "@packages/shared-components/services/constants";

interface SearchProps {
  course_data: any;
  uni_data: any;
  clearingSubjects: any;
  universalSearchPanel: any;
  isClearingEnabled?: boolean;
}

export default function Search({
  course_data,
  uni_data,
  universalSearchPanel,
  clearingSubjects,
  isClearingEnabled,
}: SearchProps) {
  const customGA = {
    page_name: typeof window !== 'undefined' ? localStorage?.getItem("gaPageName") || "" : "",
  };
  
  const searchTabClick = (tabName: string) => {
    setsearchFormHandle((preData) => ({ ...preData, activeTab: tabName }));
  };
  const rightMenuAction = (actionType: string) => {
    emitter.emit("rightMenuActionclose", actionType);
  };
 
  const [searchFormHandle, setsearchFormHandle] = useState({
    activeTab: universalSearchPanel[0]?.navName?.toLowerCase(),
    isCourseType: false,
    isSubjectClicked: false,
    isLocationClicked: false,
    isAdviceClicked: false,
    isUniversityClicked: false,
    courseType: { qualUrl: "degree", qualCode: "M", qualDesc: "Undergraduate" },
    university: "",
    subject: {},
    location: {},
    advice: "",
  });
  const [isUcasPopupOpen, SetIsUcasPopupOpen] = useState(false);
  const ucasClick = () => {
    SetIsUcasPopupOpen(true);
    const body = document.body;
    body.classList.add("overflow-y-hidden");
  };

  const ucasClose = () => {
    const body = document.body;
    SetIsUcasPopupOpen(false);
    body.classList.remove("overflow-y-hidden");
  };
  
  
  const ucaspoint = parseUCASCookie();
  return (
    <div className="bg-white absolute top-0 left-0 right-0 z-10">
      <div className="max-w-container w-full mx-auto flex flex-col px-[16px] pt-[8px] pb-[56px] md:pt-[16px] md:pb-[32px] xl:px-0">
        <button type="button" className="flex self-end relative">
          <svg
            aria-label="close-button"
            className="cursor-pointer"
            onClick={() => rightMenuAction("SEARCH")}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 29L29 3M3 3L29 29"
              stroke="#333F48"
              strokeWidth="2.67"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div className="flex flex-col items-center justify-center lg:min-h-[150px] gap-y-[16px] mt-[16px] md:mt-[-16px]">
          <ul className="flex items-center gap-[4px] cursor-pointer">
            {universalSearchPanel?.map((items: any, index: number) => (
              <li
                key={index + 1}
                className={`rounded-[20px] px-[12px] py-[8px] small font-semibold inline-block hover:bg-black hover:text-white border border-grey-500 ${
                  searchFormHandle.activeTab === items?.navName?.toLowerCase()
                    ? "bg-black text-white"
                    : "bg-white text-black"
                }`}
                onClick={() => searchTabClick(items?.navName?.toLowerCase())}
              >
                {items?.navTitle}
              </li>
            ))}
          </ul>

          <div className="w-full lg:max-w-[800px]">
            <div className="flex flex-col gap-[24px] min-h-[60px]">
              {(() => {
                switch (searchFormHandle?.activeTab?.toLocaleLowerCase()) {
                  case SearchTabIntNames.Clearing:
                    return (
                      <>
                        <ClearingSearch
                          customGA={{
                            event: "clearing_events",
                            eventName: "topnav_search",
                            clearing: "clearing",
                          }}
                          placeholder={universalSearchPanel[0]?.navCtAlabel}
                          clearingCourseList={
                            clearingSubjects?.clearingSubjectList
                          }
                          locationList={clearingSubjects?.locationList}
                        />
                        {ucaspoint ? (
                          <div className="flex items-center justify-center small">
                            <p className="small text-grey300 small">
                              Your UCAS points
                            </p>
                            <div className="flex items-center min-w-[36px] py-[6px] px-[14px] ml-[8px] mr-[16px] rounded-[4px] font-semibold cursor-pointer bg-positive-default text-white">
                              {ucaspoint}
                            </div>
                            <button
                              className="text-blue-500 font-semibold hover:underline"
                              onClick={() => {
                                ucasClick();
                                GA4DataLayer({
                                  event: GAConstants.track_event,
                                  event_name: "ucas_calculator_open",
                                  click_text:"recalculate",
                                });
                              }}
                            >
                              Recalculate
                            </button>
                            {isUcasPopupOpen && (
                              <UcasComponent
                                onClose={ucasClose}
                                isUcasOpen={isUcasPopupOpen}
                              />
                            )}
                          </div>
                        ) : (
                          <div className="flex items-center justify-center small">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.66678 6.11111H12.3334M12.3334 13.8889V11.5556M10.0001 13.8889H10.0079M7.66678 13.8889H7.67456M7.66678 11.5556H7.67456M10.0001 11.5556H10.0079M12.3334 9.22222H12.3412M10.0001 9.22222H10.0079M7.66678 9.22222H7.67456M6.11122 17H13.889C14.7481 17 15.4446 16.3036 15.4446 15.4444V4.55556C15.4446 3.69645 14.7481 3 13.889 3H6.11122C5.25211 3 4.55566 3.69645 4.55566 4.55556V15.4444C4.55566 16.3036 5.25211 17 6.11122 17Z"
                                stroke="#4664DC"
                                strokeWidth="1.67"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            &nbsp;
                            <button
                             onClick={() => {
                                ucasClick();
                                GA4DataLayer({
                                  event: GAConstants.track_event,
                                  event_name: "ucas_calculator_open",
                                  click_text:"calculate_them",
                                });
                              }}
                              className="text-blue-500 font-semibold hover:underline"
                            >
                              Calculate your UCAS points
                            </button>
                            {isUcasPopupOpen && (
                              <UcasComponent
                                onClose={ucasClose}
                                isUcasOpen={isUcasPopupOpen}
                              />
                            )}
                          </div>
                        )}
                      </>
                    );
                  case SearchTabIntNames.Course:
                    return (
                      <>
                        <CourseTab
                          showlocation={true}
                          placeholder={universalSearchPanel[0]?.navCtAlabel}
                          data={course_data}
                          searchFormHandle={searchFormHandle}
                          setsearchFormHandle={setsearchFormHandle}
                          gaEventName="topnav_search"
                        />
                        {ucaspoint ? (
                          <div className="flex items-center justify-center small">
                            <p className="small text-grey300 small">
                              Your UCAS points
                            </p>
                            <div className="flex items-center min-w-[36px] py-[6px] px-[14px] ml-[8px] mr-[16px] rounded-[4px] font-semibold cursor-pointer bg-positive-default text-white">
                              {ucaspoint}
                            </div>
                            <button
                              className="text-blue-500 font-semibold hover:underline"
                              onClick={() => {
                                ucasClick();
                                GA4DataLayer({
                                  event: GAConstants.track_event,
                                  event_name: "ucas_calculator_open",
                                  click_text:"recalculate",
                                });
                              }}
                            >
                              Recalculate
                            </button>
                            {isUcasPopupOpen && (
                              <UcasComponent
                                onClose={ucasClose}
                                isUcasOpen={isUcasPopupOpen}
                              />
                            )}
                          </div>
                        ) : (
                          <div className="flex items-center justify-center small">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.66678..."
                                stroke="#0F172A"
                                strokeWidth="1.67"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            <div className="ml-[4px] mr-[8px]">
                              Don’t know your UCAS points?
                            </div>
                            <button
                              onClick={() => {
                                ucasClick();
                                GA4DataLayer({
                                  event: GAConstants.track_event,
                                  event_name: "ucas_calculator_open",
                                  click_text:"calculate_them",
                                });
                              }}
                              className="text-blue-500 font-semibold hover:underline"
                            >
                              Calculate them
                            </button>
                            {isUcasPopupOpen && (
                              <UcasComponent
                                onClose={ucasClose}
                                isUcasOpen={isUcasPopupOpen}
                              />
                            )}
                          </div>
                        )}
                      </>
                    );
                  case SearchTabIntNames.Uni:
                    return (
                      <>
                        <UniversityTab
                          placeholder={universalSearchPanel[2]?.navCtAlabel}
                          searchFormHandle={searchFormHandle}
                          setsearchFormHandle={setsearchFormHandle}
                          data={uni_data}
                          gaEventName="topnav_search"
                          isClearingEnabled={isClearingEnabled}
                        />
                        <div className="flex justify-center">
                          <a
                            href="/degrees/find-university/"
                            className="flex items-center gap-[4px] text-blue-500 small font-semibold hover:underline"
                            onClick={() => {
                              GA4DataLayer({
                                event: GAConstants.track_event,
                                event_name: "topnav_search",
                                // data_label: `view_all_clicks`,
                                // data_label2: "university_clicks",
                                // page_name:
                                //   localStorage?.getItem("gaPageName") || "",
                              });
                            }}
                          >
                            Browse unis A-Z
                            <Image
                              src="/static/assets/icons/arrow-right.svg"
                              width={20}
                              height={20}
                              alt="Right Arrow"
                            />
                          </a>
                        </div>
                      </>
                    );
                  case SearchTabIntNames.Advice:
                    return (
                      <>
                        <AdviceTab
                          placeholder={universalSearchPanel[2]?.navCtAlabel}
                          searchFormHandle={searchFormHandle}
                          setsearchFormHandle={setsearchFormHandle}
                        />
                        <div className="flex justify-center">
                          <a
                            href="/advice/"
                            className="flex items-center gap-[4px] text-blue-500 small font-semibold hover:underline"
                          >
                            Browse advice
                            <Image
                              src="/static/assets/icons/arrow-right.svg"
                              width={20}
                              height={20}
                              alt="Right Arrow"
                            />
                          </a>
                        </div>
                      </>
                    );
                  default:
                    return null;
                }
              })()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
